const AI_VIDEO_INTERVIEW_STATUS = {
  PENDING: "Video Task In Progress",
  COMPLETED: "Video Task Completed",
  CONFIRMED: "Video Task Confirmed",
  FAILED: "Video Task Failed",
};

const AI_VIDEO_MODAL_MODE = {
  ACTION: "action",
  AI: "ai",
};

const AI_VIDEO_TASK_DISPLAY_STATE = {
  EMPTY: "empty",
  SUBMITTING: "submitting",
  PROCESSING: "processing",
  REVIEW: "review",
  FINALIZING: "finalizing",
  ERROR: "error",
  READY: "ready",
};

// Helper to check if status is pending
const isVideoTaskPending = (status) => status === AI_VIDEO_INTERVIEW_STATUS.PENDING;

// Helper to check if status is completed
const isVideoTaskCompleted = (status) => status === AI_VIDEO_INTERVIEW_STATUS.COMPLETED;

const isVideoTaskConfirmed = (status) => status === AI_VIDEO_INTERVIEW_STATUS.CONFIRMED;

// Helper to check if status is failed
const isVideoTaskFailed = (status) => status === AI_VIDEO_INTERVIEW_STATUS.FAILED;

const isVideoTaskPollingState = (status) => isVideoTaskPending(status) || isVideoTaskConfirmed(status);

const isVideoTaskFinalizing = (status) => isVideoTaskConfirmed(status);

const isVideoTaskReviewable = (status) => isVideoTaskCompleted(status);

const isVideoTaskErrored = (task) => Boolean(task?.errorMessage) || isVideoTaskFailed(task?.status);

const resolveVideoTask = ({ cachedTask, questionTask }) => (cachedTask !== undefined ? cachedTask : questionTask);

const getPreferredGeneratedVideoUrl = (task) => task?.videoUrlCaption || task?.videoUrl || null;

const getVideoTaskDisplayState = (
  task,
  {
    isSubmittingFreshAttempt = false,
    hasQuestionVideo = false,
    requireReviewThumbnail = false,
    emptyState = AI_VIDEO_TASK_DISPLAY_STATE.EMPTY,
  } = {}
) => {
  if (isSubmittingFreshAttempt) {
    return AI_VIDEO_TASK_DISPLAY_STATE.SUBMITTING;
  }

  if (!task) {
    return hasQuestionVideo ? AI_VIDEO_TASK_DISPLAY_STATE.READY : emptyState;
  }

  if (isVideoTaskErrored(task)) {
    return AI_VIDEO_TASK_DISPLAY_STATE.ERROR;
  }

  if (isVideoTaskFinalizing(task.status)) {
    return AI_VIDEO_TASK_DISPLAY_STATE.FINALIZING;
  }

  if (isVideoTaskReviewable(task.status)) {
    if (requireReviewThumbnail && !task?.thumbnailUrl) {
      return AI_VIDEO_TASK_DISPLAY_STATE.READY;
    }

    return AI_VIDEO_TASK_DISPLAY_STATE.REVIEW;
  }

  return AI_VIDEO_TASK_DISPLAY_STATE.PROCESSING;
};

// Polling configuration
const AI_VIDEO_INTERVIEW_CONFIG = {
  POLLING_INTERVAL: 10000, // 10 seconds - poll until terminal status
  STORAGE_KEY: "aiVideoInterviewJob",
};

export default AI_VIDEO_INTERVIEW_STATUS;

export {
  AI_VIDEO_INTERVIEW_CONFIG,
  AI_VIDEO_MODAL_MODE,
  AI_VIDEO_TASK_DISPLAY_STATE,
  isVideoTaskPending,
  isVideoTaskCompleted,
  isVideoTaskConfirmed,
  isVideoTaskFailed,
  isVideoTaskPollingState,
  isVideoTaskFinalizing,
  isVideoTaskReviewable,
  isVideoTaskErrored,
  resolveVideoTask,
  getPreferredGeneratedVideoUrl,
  getVideoTaskDisplayState,
};
